export default "__VITE_ASSET__CzeTztfS__"